import { render } from "./ImageMultiple.vue?vue&type=template&id=68ce7535"
import script from "./ImageMultiple.vue?vue&type=script&lang=js"
export * from "./ImageMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__